/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 充值卡激活
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  giftCardReq: order.GiftCardReq,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: order.RechargeByCardRes;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "post",
    url: `/order/ecard`,
    data: giftCardReq,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
